export const persistState = (storageKey: string, state: any) => {
    if (typeof window !== 'undefined') {
      return window.localStorage.setItem(storageKey, JSON.stringify(state));
    }
  };
  
export const getIntialState = (storageKey: string) => {
    if (typeof window !== 'undefined') {
      const savedState = window.localStorage.getItem(storageKey);
      try {
        if (!savedState) {
          return undefined;
        }
        return JSON.parse(savedState ?? '{}');
      } catch (e) {
        console.error('Error loading state : ' + storageKey);
        return undefined;
      }
    }
  };
  
  export const persistSessionState = (storageKey: string, state: any) => {
    if (typeof window !== 'undefined') {
      return window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    }
  };
  
export const getIntialSessionState = (storageKey: string) => {
    if (typeof window !== 'undefined') {
      const savedState = window.sessionStorage.getItem(storageKey);
      try {
        if (!savedState) {
          return undefined;
        }
        return JSON.parse(savedState ?? '{}');
      } catch (e) {
        console.error('Error loading state : ' + storageKey);
        return undefined;
      }
    }
  };
  